import { defineMessages, useIntl } from 'react-intl';
import { HStack } from '@cbhq/cds-web/layout';
import { Pressable } from '@cbhq/cds-web/system/Pressable';
import { Text } from '@cbhq/cds-web/typography/Text';

const messages = defineMessages({
  productsSelectedCount: {
    id: 'Team.inviteTray.productsSelectedCount',
    defaultMessage: '{selected} of {total} products selected',
    description: 'Count of selected products in the invite tray access section',
  },
  selectAll: {
    id: 'Team.inviteTray.selectAll',
    defaultMessage: 'Select all',
    description: 'Action to select all products in the invite tray access section',
  },
  deselectAll: {
    id: 'Team.inviteTray.deselectAll',
    defaultMessage: 'Deselect all',
    description: 'Action to deselect all products in the invite tray access section',
  },
  toggleAllProductsAccessibilityLabel: {
    id: 'Team.inviteTray.toggleAllProductsAccessibilityLabel',
    defaultMessage: 'Toggle all products',
    description:
      'Accessibility label for selecting or deselecting all products in the invite tray access footer',
  },
});

const ACTION_STYLE = { cursor: 'pointer' } as const;

export type ProductAccessFooterParams = {
  selectedCount: number;
  totalCount: number;
  allSelected: boolean;
  onSelectAll: () => void;
  onDeselectAll: () => void;
};

export function ProductAccessFooter({
  selectedCount,
  totalCount,
  allSelected,
  onSelectAll,
  onDeselectAll,
}: ProductAccessFooterParams) {
  const { formatMessage } = useIntl();

  return (
    <HStack alignItems="center" gap={1}>
      <Text as="span" font="label2" color="fgMuted">
        {formatMessage(messages.productsSelectedCount, {
          selected: selectedCount,
          total: totalCount,
        })}
      </Text>
      <Text as="span" font="label2" color="fgMuted">
        ·
      </Text>
      <Pressable
        onClick={allSelected ? onDeselectAll : onSelectAll}
        background="transparent"
        noScaleOnPress
        accessibilityLabel={formatMessage(messages.toggleAllProductsAccessibilityLabel)}
      >
        <Text
          as="span"
          font="label2"
          color="fgMuted"
          textDecoration="underline"
          style={ACTION_STYLE}
        >
          {formatMessage(allSelected ? messages.deselectAll : messages.selectAll)}
        </Text>
      </Pressable>
    </HStack>
  );
}
